import AdaptiveQuizPage from './AdaptiveQuizPage';

export default AdaptiveQuizPage;
